export default __webpack_public_path__ + "static/media/onion.108d3f7b.png";